/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Usage_ColInputs */

const en_admin_invite_codes_usage_col = /** @type {(inputs: Admin_Invite_Codes_Usage_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

const zh_admin_invite_codes_usage_col = /** @type {(inputs: Admin_Invite_Codes_Usage_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已用`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Admin_Invite_Codes_Usage_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_usage_col = /** @type {((inputs?: Admin_Invite_Codes_Usage_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Usage_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_usage_col(inputs)
	return zh_admin_invite_codes_usage_col(inputs)
});
export { admin_invite_codes_usage_col as "admin.invite_codes.usage_col" }